
import '../scss/main.scss';
import FlowField from './modules/flow-field';

function init() {
  const mainCanvas = document.querySelector('#canvas');
  window.canvas = new FlowField(mainCanvas);
}

if (document.readyState === 'interactive') {
  init();
} else {
  document.addEventListener('DOMContentLoaded', init);
}
